import { t } from 'i18next'

import { Filters } from '~/components/Filters'

import { retailMediaWallets } from '../../store/common/filters'

import styles from './styles.module.css'

type CheckingAccountTableToolbarProps = {
  showFilters: boolean
  total: number
}

export const CheckingAccountTableToolbar = ({
  showFilters,
  total
}: CheckingAccountTableToolbarProps) => {
  if (!showFilters) return null

  return (
    <div className={styles.toolbar}>
      <Filters {...retailMediaWallets} />
      {total > 0 ? (
        <p className={styles.meta}>
          <strong>{total}</strong> {t(`rm:${total > 1 ? 'wallets' : 'wallet'}`)}
        </p>
      ) : null}
    </div>
  )
}
